/**
 * remark-gfm, minus the GFM "autolink literal" extension.
 *
 * Why this exists: `remark-gfm`'s autolink-literal piece
 * (`mdast-util-gfm-autolink-literal`) builds a regex with a *lookbehind*
 * assertion — `/(?<=^|\s|\p{P}|\p{S})…/gu`. WebKit only shipped regex
 * lookbehind in Safari 16.4 (March 2023), so on iOS/iPadOS < 16.4 that regex
 * throws `SyntaxError: Invalid regular expression: invalid group specifier
 * name` the moment react-markdown runs on the client. SSR (Node) renders fine,
 * so the article is visible, but the throw aborts client hydration and
 * cascades into HierarchyRequestError + "Maximum update depth exceeded".
 * Lookbehind cannot be transpiled away, so we drop the feature instead.
 *
 * We keep every other GFM feature (tables, strikethrough, task lists,
 * footnotes). Bare URLs in prose (e.g. `book.parks.qld.gov.au`) render as
 * plain text rather than auto-linking — our posts use explicit
 * `[text](url)` links anyway.
 *
 * Mirrors the upstream `remark-gfm` plugin shape; only the autolink-literal
 * extension is omitted. See node_modules/remark-gfm/lib/index.js.
 */
import { gfmFootnoteFromMarkdown } from "mdast-util-gfm-footnote";
import { gfmStrikethroughFromMarkdown } from "mdast-util-gfm-strikethrough";
import { gfmTableFromMarkdown } from "mdast-util-gfm-table";
import { gfmTaskListItemFromMarkdown } from "mdast-util-gfm-task-list-item";
import { gfmFootnote } from "micromark-extension-gfm-footnote";
import { gfmStrikethrough } from "micromark-extension-gfm-strikethrough";
import { gfmTable } from "micromark-extension-gfm-table";
import { gfmTaskListItem } from "micromark-extension-gfm-task-list-item";

const emptyOptions = {};

export default function remarkGfmNoAutolink(options) {
  const self = this;
  const settings = options || emptyOptions;
  const data = self.data();

  const micromarkExtensions =
    data.micromarkExtensions || (data.micromarkExtensions = []);
  const fromMarkdownExtensions =
    data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);

  micromarkExtensions.push(
    gfmFootnote(),
    gfmStrikethrough(settings),
    gfmTable(),
    gfmTaskListItem(),
  );
  fromMarkdownExtensions.push(
    gfmFootnoteFromMarkdown(),
    gfmStrikethroughFromMarkdown(),
    gfmTableFromMarkdown(),
    gfmTaskListItemFromMarkdown(),
  );
}
